export default __webpack_public_path__ + "static/media/small_mobile_image_watermark.ced3bd2d.svg";